import React, { useState, useEffect } from 'react';
import api from '../api';
import LoadingSpinner from './LoadingSpinner';
import axios from 'axios';
import './Students.css';

const Students = () => {
  const [students, setStudents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        setIsLoading(true);
        setError('');
        const token = localStorage.getItem('token');
        const res = await api.get('/students', {
          headers: {
            'x-auth-token': token,
          },
        });
        setStudents(res.data);
      } catch (err) {
        console.error('Error fetching students:', err.response.data);
        setError('Failed to load students data. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };
    fetchStudents();
  }, []);

  return (
    <div className="students-container">
      <div className="main-content">
        <header className="students-header">
          <h1>Students</h1>
        </header>
        
        {error && (
          <div className="error-message">
            <p>{error}</p>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        )}
        
        <div className="students-list">
          {isLoading ? (
            <LoadingSpinner size="medium" message="Loading students..." />
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>SL No.</th>
                  <th>Name</th>
                  <th>Student ID</th>
                  <th>Parent</th>
                  <th>Bus</th>
                  <th>Face Registered</th>
                </tr>
              </thead>
              <tbody>
                {students.length > 0 ? (
                  students.map((student, index) => (
                    <tr key={student._id}>
                      <td>{index + 1}</td>
                      <td>{student.name}</td>
                      <td>{student.studentId}</td>
                      <td>{student.parent ? student.parent.name : 'N/A'}</td>
                      <td>{student.bus ? student.bus.busNumber : 'N/A'}</td>
                      <td>{student.faceEmbeddings && student.faceEmbeddings.length > 0 ? 'Yes' : 'No'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                      No students found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Students;
